module.exports = __webpack_public_path__ + "static/media/collection-bird-01-effect.54feb6df.png";